import { render, staticRenderFns } from "./Billboards.vue?vue&type=template&id=a0db523c&scoped=true"
import script from "./Billboards.vue?vue&type=script&lang=js"
export * from "./Billboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0db523c",
  null
  
)

export default component.exports